import { render, staticRenderFns } from "./column-skus.vue?vue&type=template&id=6249515e&scoped=true&"
import script from "./column-skus.vue?vue&type=script&lang=ts&"
export * from "./column-skus.vue?vue&type=script&lang=ts&"
import style0 from "./column-skus.vue?vue&type=style&index=0&id=6249515e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6249515e",
  null
  
)

export default component.exports